import { render, staticRenderFns } from "./UserNotificationApp.vue?vue&type=template&id=f242399c&"
import script from "./UserNotificationApp.vue?vue&type=script&lang=js&"
export * from "./UserNotificationApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports